import { MsArrowRight as n } from "@sunrise/icons";
import { addTracking as a } from "@sunrise/tracking";
import { defineComponent as l } from "vue";
const f = l({
  name: "CsLink",
  components: {
    MsArrowRight: n
  },
  props: {
    href: { default: null, type: String },
    target: { default: null, type: String },
    rel: { default: null, type: String },
    suffix: { default: null, type: String },
    hasClickArea: {
      type: Boolean,
      default: !1
    },
    sign: String,
    isPRG: Boolean,
    isDisabled: {
      type: Boolean,
      default: !1
    },
    isSuffixIcon: {
      type: Boolean,
      default: !1
    },
    hasAnchorIcon: {
      type: Boolean,
      default: !1
    },
    tracking: {
      type: Array
    }
  },
  setup(e) {
    let t = null;
    return e.tracking && (t = a(e.tracking)), {
      trackingId: t
    };
  }
});
export {
  f as default
};
